export const environment = {
    serverHost: '',
    token: '',
};
